import { styled } from '@linaria/react';
import { colors, layout, semantic, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space[3]} ${space[4]} ${space[5]};
  display: flex;
  flex-direction: column;
  gap: ${space[5]};

  [data-testid='basket-contents'] > *:first-child {
    padding-right: ${space[8]};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[8]};

    [data-testid='basket-contents'] > *:first-child {
      padding-right: 0;
    }
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${space[3]};
  padding: ${space[4]};
  background: ${colors.white};
  border-top: 1px solid ${semantic.border.subtle};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[5]} ${space[8]};
  }
`;
